import Vue from 'vue'
import VueRouter from 'vue-router'
// import Index from 'pages/Index'
// import Invoices from 'pages/Invoices'
import InvoicesAdd from 'pages/Invoices/Add'

Vue.use(VueRouter)

const Layout = {
  template: `
    <div>
      <router-view class="view"></router-view>
    </div>
  `
}

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  linkActiveClass: 'active',
  routes: [
    /*
    { path: '/', name: 'index', component: Index },
    { path: '/invoices', name: 'invoices', component: Invoices },
    { path: '/invoices/new', name: 'invoices/add', component: InvoicesAdd }
    */
    { path: '/', name: 'invoices/add', component: InvoicesAdd }
  ]
})

Layout.router = router;
(new Vue(Layout)).$mount('#app')



/** WEBPACK FOOTER **
 ** ./src/main.js
 **/